import React, { Component } from 'react';
import Home from './pages/home';
import NotFound from './pages/NotFound';
import {Route, Router, BrowserRouter, Redirect, Switch} from 'react-router-dom'
import Session from './services/session.js'
import Tours from './pages/tours';
import Accomodation from './pages/accomodation';
import FlightsTrains from './pages/FlightsTrains';
import Transfers from './pages/Transfers';
import TransferPage from './pages/TransferPage';
import Events from './pages/Events';
import Visa from './pages/Visa';
import AboutUs from './pages/AboutUs';
import Blog from './pages/Blog';
import BlogPage from './pages/BlogPage';
import Corporate from './pages/Corporate';
import Destinations from './pages/Destinations';
import DestinationPage from './pages/DestinationPage';
import AccomodationPage from './pages/accomodationPage';
import TourPage from './pages/TourPage';
import ExcursionPage from './pages/ExcursionPage';
import Excursions from './pages/Excursions';
import Services from './pages/Services';

import 'react-tippy/dist/tippy.css';
import './App.css';
import 'animate.css/animate.min.css';
import thumbsODown from 'react-icons-kit/fa/thumbsODown';


function createLocalizedRoutes(locale) {
  return (
    <Route path={`/${locale}/`} render={ (props) => <MainNavigation {...props} locale={locale} />}/>
     
  );  
}

/*
const MainNavigation = (props) => 
  (
    <Switch>
        <Route exact path={`${props.match.url}/`} render={ () => <Home /> } />
        <Route path="*" component={NotFound} />
    </Switch>
  )
*/

class ScrollToTop extends Component {
  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      window.scrollTo(0, 0)
    }
  }

  render() {
    return this.props.children
  }
}

class NavAccomodation extends Component {

  constructor(props) {
    super(props);
    
  }
  
  render() {
    return (
      <Switch>
        {
          Session.model.accomodationPages.map( a => 
            <Route exact path={`${this.props.match.url}/${a.name}`} render={ () => <AccomodationPage data = {a} /> }/>
           )
        }
      </Switch>
    )
  }
}

class MainNavigation extends Component {

  constructor(props) {
    super(props);
    this.state = {
      model: false
    }
  }

  componentDidMount() {
    Session.setLanguage(this.props.locale).then( () =>
      {
        this.setState({
          model: true
        });
      }
    );
  };

  
  render() {
      const props = this.props;
      //console.log(Session.language);
        if (this.state.model)
        {
          window.qloaded();
        }
      return ( this.state.model ? <Switch>
            <Route exact path={`${props.match.url}`} render={ () => <Home /> } />
            <Route exact path={`${props.match.url}/`} render={ () => <Home /> } />
            <Route exact path={`${props.match.url}/destinations`} render={ () => <Destinations /> }/>
            <Route exact path={`${props.match.url}/destinations/:city`} render={ ({match}) => <DestinationPage city={match.params.city} /> }/>
            <Route exact path={`${props.match.url}/tours`} render={ () => <Tours /> }/>
            {
              Session.model.tourPages.map( a => 
                <Route exact path={`${props.match.url}/tours/${a.name}`} render={ () => <TourPage data = {a} /> }/> )
            }
            {
              Session.model.data.tourtypes.map( a => 
                <Route exact path={`${props.match.url}/tours/${a.name}`} render={ () => <Tours type = {a.name} /> }/> )
            }

            {/*
            <Route exact path={`${props.match.url}/tours/excursions/`} render={ () => <Tours type='excursion' /> }/>
            <Route exact path={`${props.match.url}/tours/excursions/city/:city`} render={ ({match}) => <Tours city={match.params.city} type='excursion' /> }/> 
            <Route exact path={`${props.match.url}/tours/tour_packages`} render={ () => <Tours type='tour_package' /> }/>
            <Route exact path={`${props.match.url}/tours/tour_packages/city/:city`} render={ ({match}) => <Tours city={match.params.city} type='tour_package' /> }/>
            {
              Session.model.tourPages.filter(f => f.type = 'tour_package').map( a => 
                <Route exact path={`${props.match.url}/tours/tour_packages/${a.name}`} render={ () => <TourPage data = {a} /> }/> )
            }
            {
              Session.model.tourPages.filter(f => f.type = 'excursion').map( a => 
                <Route exact path={`${props.match.url}/tours/excursions/${a.name}`} render={ () => <TourPage data = {a} /> }/> )
            }
            */}
            <Route exact path={`${props.match.url}/excursions`} render={ () => <Excursions /> }/>
            {
              Session.model.excursionPages.map( a => 
              <Route exact path={`${props.match.url}/excursions/${a.name}`} render={ () => <ExcursionPage data = {a} /> }/> )
            }
          

            <Route exact path={`${props.match.url}/accomodation`} render={ () => <Accomodation /> }/>
            <Route exact path={`${props.match.url}/accomodation/city/:city`} render={ ({match}) => <Accomodation city={match.params.city} /> }/>
            <Route exact path={`${props.match.url}/accomodation/hotels`} render={ () => <Accomodation type='hotel' /> }/>
            {/*<Route exact path={`${props.match.url}/accomodation/hotels/city/:city`} render={ ({match}) => <Accomodation type='hotel' city={match.params.city} /> }/> */}
            <Route exact path={`${props.match.url}/accomodation/apartments`} render={ () => <Accomodation type='apartments' /> }/>
            {
              Session.model.accomodationPages.filter(f => f.type = 'apartments').map( a => 
                <Route exact path={`${props.match.url}/accomodation/apartments/${a.name}`} render={ () => <AccomodationPage data = {a} /> }/> )
            }
            {
              Session.model.accomodationPages.filter(f => f.type = 'hotel').map( a => 
                <Route exact path={`${props.match.url}/accomodation/hotels/${a.name}`} render={ () => <AccomodationPage data = {a} /> }/> )
            }
            <Route exact path={`${props.match.url}/flighttrains`} render={ () => <FlightsTrains /> } />

            <Route exact path={`${props.match.url}/transfers`} render={ () => <Transfers /> } />
            {
              Session.model.transfersPages.map( t => 
                <Route exact path={`${props.match.url}/transfers/${t.name}`} render={ () => <TransferPage data = {t} /> }/> )
            }
            <Route exact path={`${props.match.url}/events`} render={ () => <Events /> } />
            <Route exact path={`${props.match.url}/visa`} render={ () => <Visa /> } />
            <Route exact path={`${props.match.url}/aboutus`} render={ () => <AboutUs /> } />
            <Route exact path={`${props.match.url}/services`} render={ () => <Services /> } />
            <Route exact path={`${props.match.url}/blog`} render={ () => <Blog /> } />
            { 
              Session.model.blogPages.filter(f => f.lang == Session.language).map( t => 
              <Route exact path={`${props.match.url}/blog/${t.name}`} render={ () => <BlogPage data ={t} /> } />)
            }
            <Route exact path={`${props.match.url}/corporate`} render={ () => <Corporate /> } />
            {<Route path="*" component={NotFound} />}
      </Switch> : 
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '200px'}}>
        <img src="/imgs/Logo.svg" width="100"/>
        <img src="/imgs/loading_min.gif" height="100"/>
      </div>
      
    );
  }
}


class App extends Component {
  render() {
    return (
      /*Для задачи Перезагрузка страницы (Refresh) либо <BrowserRouter forceRefresh={true}>,
      либо обернуть Routes в <ScrollToTop> */
      <BrowserRouter forceRefresh={true}>
        <Switch>
        {createLocalizedRoutes('en')}
        {createLocalizedRoutes('ru')}
        {createLocalizedRoutes('es')}
        <Route exact path="/" component={() => <Redirect to="/en" />}/>
        <Route path="*" component={NotFound} />
        </Switch>
      </BrowserRouter>)

    
  }
}

//import React from 'react';



export default App;